module.exports = __webpack_public_path__ + "img/orange.33113da5.jpg";